import { createSlice } from '@reduxjs/toolkit';

const ModalStage = {
    CREATE_NEW_ETH: 'CREATE_NEW_ETH',
    CONNECT_NEW_ETH: 'CONNECT_NEW_ETH',
    SUCCESS_NEW_ETH: 'SUCCESS_NEW_ETH',
    PUBLIC_MINT: 'PUBLIC_MINT',
    // OG claim (legacy Ethereum holders) -- Robinhood Chain is EVM-only, no
    // Solana wallet is ever involved in this flow.
    OG_CONNECT: 'OG_CONNECT',
    OG_STATUS: 'OG_STATUS',
    OG_NOT_ELIGIBLE: 'OG_NOT_ELIGIBLE',
    OG_MINT: 'OG_MINT',
    FINISH_X: 'FINISH_X',
};

const initialState = {
    stage: null,
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        setModalStage(state, action) {
            state.stage = action.payload;
        },
        resetModalState(state) {
            state.stage = null;
        },
    },
});

export const { setModalStage, resetModalState } = modalSlice.actions;
export { ModalStage };
export default modalSlice.reducer;
